import React, { useState, useEffect } from 'react';
import './style.css';
import Box from '@mui/material/Box';
import { Typography } from '@mui/material';
import Grid from '@mui/material/Grid';
import Checkbox from '@mui/material/Checkbox';
import EmailIcon from '@mui/icons-material/Email';
import SendIcon from '@mui/icons-material/Send';
import http from '../../services/http-service';
import Pagination from '@mui/material/Pagination';
import Backdrop from '@mui/material/Backdrop';
import Stack from '@mui/material/Stack';
import CircularProgress from '@mui/material/CircularProgress';
import { ToastContainer, toast } from 'react-toastify';


function MutualInvite({ employerCodeForMutualInvite }) {
    const [count, setCount] = useState(0);
    const [tableData, setTableData] = useState([])
    const [openSpinner, setOpenSpinner] = useState(false);
    const [isCheckAll, setIsCheckAll] = useState(false);
    const [isCheck, setIsCheck] = useState([]);
    // const [userInfo, setUserInfo] = useState(JSON.parse(localStorage.getItem('loginUser')))

    const handleSpinnerClose = () => {
        setOpenSpinner(false);
    };
    const handleSpinnerToggle = () => {
        setOpenSpinner(!openSpinner);
    };

    useEffect(() => {
        getPreOnboardedEmpList()
        // eslint-disable-next-line
    }, []);

    const handleSelectAll = () => {
        setIsCheckAll(!isCheckAll);
        setIsCheck(tableData.map(li => li.id));
        if (isCheckAll) {
            setIsCheck([]);
        }
    };

    const sentInvitation = () => {
        if (isCheck.length === 0) {
            toast.error("Please select atleast one employee.",{
                toastId: "toastId1"
              })
            return
        }
        handleSpinnerToggle()
        http('employer/manual_invites_to_employees_via_mail/', 'POST', isCheck)
            .then(res => res.data)
            .then(res => {
                if (res.status) {
                    toast.success(res.message,{
                        toastId: "toastId2"
                      })
                    getPreOnboardedEmpList()
                }
                else {
                    toast.error(res.message,{
                        toastId: "toastId3"
                      })
                }
                handleSpinnerClose()
            },
                err => {
                    handleSpinnerClose()
                    console.log('err....', err)
                });
    }

    const getPreOnboardedEmpList = (event, page) => {
        let params = {
            "employer_code": employerCodeForMutualInvite,
            "page": page
        }
        handleSpinnerToggle()
        http('employer/employee_pre_boarded_list/', 'GET', '', params)
            .then(res => res.data)
            .then(res => {
                if (res.status) {
                    setCount(0)
                    setCount(Math.ceil(res.count / res.page_size))
                    res.results.forEach(elem => {
                        elem['selected'] = false
                    })
                    setTableData(res.results)
                }
                else {
                    toast.error(res.message,{
                        toastId: "toastId4"
                      })
                }
                handleSpinnerClose()
            },
                err => {
                    handleSpinnerClose()
                    console.log('err....', err)
                });
    }

    return (
        <div className=''>
            <ToastContainer />

            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={openSpinner}
            >
                <CircularProgress color="inherit" />
            </Backdrop>

            <Box sx={{ width: '100%', typography: 'body1' }}>
                <Typography variant="h2" component="h2" className='settingTabHeading'>
                    Manual Invite
                </Typography>
                <Typography variant="h6" component="h6" className='settingverifyTxt'>
                    Manually select and send invites to pre-boarded employees
                </Typography>

                {tableData.length > 0 ? (
                    <div>
                        <div className='customTable'>
                            <table>
                                <thead>
                                    <tr>
                                        <th><Checkbox size="small" onChange={handleSelectAll} name="selectAll" id="selectAll" checked={isCheckAll} /> Name</th>
                                        <th>User Id</th>
                                        <th>Email</th>
                                        <th>Sent</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        tableData.map((cell, index) => (
                                            <tr key={index}>
                                                <td key={cell.name + index}> <Checkbox size="small" id={cell.id.toString()} checked={isCheck.includes(cell.id)}
                                                    onChange={(e) => {
                                                        cell.selected = e.target.checked
                                                        setIsCheck([...isCheck, cell.id]);
                                                        if (!e.target.checked) {
                                                            setIsCheck(isCheck.filter(item => item !== cell.id));
                                                        }
                                                        let selectAll = tableData.filter(item => item.selected !== false)
                                                        if (tableData.length !== selectAll.length) {
                                                            setIsCheckAll(false)
                                                        } else {
                                                            setIsCheckAll(true)
                                                        }
                                                    }}
                                                /> {cell.name}  </td>
                                                <td key={cell.employee_code + index}> {cell.employee_code} </td>
                                                <td key={cell.email + index}> {cell.email} </td>
                                                <td key={'email_icon' + index}> {cell.is_sent ? <EmailIcon /> : ""}  </td>
                                            </tr>
                                        ))
                                    }
                                </tbody>
                            </table>


                        </div>
                        <Grid container mt={1}>
                            <Grid item xs={11} >
                                <Stack spacing={2} className="centerPagination">
                                    <Pagination count={count} color="primary" onChange={getPreOnboardedEmpList} />
                                </Stack>
                            </Grid>
                            <Grid item xs={1} className="sendIcon colorBlue cursorStyle">
                                <SendIcon onClick={sentInvitation} />
                            </Grid>
                        </Grid>
                    </div>

                ) : (
                    <div className='recordNotFoundDiv'>
                        <h2>Records Not Found</h2>
                    </div >
                )}

            </Box>
        </div>
    );
}





export default MutualInvite;